import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';
import { enableProdMode } from '@angular/core';

import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { registerLocaleData } from '@angular/common';

enableProdMode();

export declare const BackgroundGeolocation: any;

platformBrowserDynamic().bootstrapModule(AppModule);

registerLocaleData(localeDe, 'de', localeDeExtra);



// WEBPACK FOOTER //
// /src/app/main.ts